// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASEURL: 'https://api.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com',
  SSO: "https://accstorefront.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/external-id_cwt",
  externalSSO: "https://accstorefront.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/external-id_cwt",
  SSODEV: "https://accstorefront.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/external-id_cwt",
  SSOQA: "https://accstorefront.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/external-id_cwt",
  SSOPROD: "https://accstorefront.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/external-id_cwt",
  PREFIX: '/occ/v2/',
  BASE_SITE: ['cwt-customer'],
  COUNTRY: ['us', 'ca'],
  ORIGIN: 'api.cq7pbmgz94-carlislec1-p1-public.model-t.cc.commerce.ondemand.com',
  gtmId: 'GTM-Test',
    auth0: {
    domain: 'auth.carlisle.com',
    clientId: 'SvTqFdJOSFO7vjJZHKNyH9RsOZcbMTr0',
    audience: 'https://api.carlisle.com/commerce',
    // Must be the Auth0 callback URL (where Auth0 redirects after login). Add this URL in Auth0 Dashboard → Application → Allowed Callback URLs.
    redirectUri: '/auth0/callback',
    logoutUrl: '/cwt-customer/USD/logout'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
